import { QueryResult, useQuery } from '@apollo/client';

import type { SubscriptionCustomers } from 'src/gql/graphql';
import { useUpdateSubscription } from 'src/state/actions/users';
import { filteredSubscriptions as filteredSubscriptionsQuery } from 'shared/graphql/subscription/queries';

type FilteredSubscriptionsData = {
  filteredSubscriptions?: Array<SubscriptionCustomers | null> | null;
};

export type UseSubscriptionsResult = Omit<QueryResult<FilteredSubscriptionsData>, 'data'> & {
  subscriptions: SubscriptionCustomers[];
  unsubscribeToDispensaries: (customerIds: string[]) => Promise<void>;
};

export default function useSubscriptions(): UseSubscriptionsResult {
  const { data, ...apolloValues } = useQuery<FilteredSubscriptionsData>(filteredSubscriptionsQuery, {
    fetchPolicy: 'network-only',
  });
  const handleUnsubscribeDispensaryCustomer = useUpdateSubscription();

  const unsubscribeToDispensaries = async (customerIds: string[]): Promise<void> => {
    await Promise.all(
      customerIds.map((customerId) =>
        handleUnsubscribeDispensaryCustomer(customerId, false, {
          refetchQueries: [{ query: filteredSubscriptionsQuery }],
        })
      )
    );
  };

  const subscriptions: SubscriptionCustomers[] = (data?.filteredSubscriptions ?? []).filter(
    (s): s is SubscriptionCustomers => s != null
  );

  return { subscriptions, ...apolloValues, unsubscribeToDispensaries };
}
